<template>
  <section class="section">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <b-steps
      v-model="activeStep"
      :has-navigation="true"
      type="is-green"
      animated
    >
      <b-step-item
        :label="$t('Detalles Básicos')"
        :clickable="true"
        icon-pack="fas"
        icon="id-card"
      >
        <basic-details
          @formSubmit="callPutUpdateOnboardRequestInfo"
          :basicDetails="requestInfo.basicDetails"
        />
      </b-step-item>
      <b-step-item
        :label="$t('Información de contacto')"
        icon-pack="fas"
        icon="address-book"
        :clickable="true"
      >
        <contact-info
          @formSubmit="callPutUpdateOnboardRequestInfo"
          :contactInfo="requestInfo.contactInfo"
        />
      </b-step-item>
      <b-step-item
        :label="$t('Detalles Finacieros')"
        icon-pack="fas"
        icon="money-check-alt"
        :clickable="true"
      >
        <financial-details
          @formSubmit="callPutUpdateOnboardRequestInfo"
          :financialDetails="requestInfo.financialDetails"
        />
      </b-step-item>
      <b-step-item
        :label="$t('Subir Archivos')"
        icon-pack="fas"
        icon="file-upload"
        :clickable="true"
      >
        <upload-files
          @formSubmit="callPutUpdateOnboardRequestInfo"
          @terminate="requestFilesReady"
          :requestFiles="requestInfo.requestFiles"
        />
      </b-step-item>
      <b-step-item
        :visible="rol == 'corporative_director'"
        :label="$t('Documentos')"
        icon-pack="fas"
        type="is-info"
        icon="folder-open"
        :clickable="true"
      >
        <documents-form
          @formSubmit="callPutUpdateOnboardRequestInfo"
          @postNewOnboardReviewRequest="callPostNewOnboardReviewRequest"
          @postRespondOnboardReviewRequest="callPostRespondOnboardReviewRequest"
          @postRequestContractSignature="callPostRequestContractSignature"
          @postSendRequestInvoice="callPostSendRequestInvoice"
          :documents="requestInfo.documents"
        />
      </b-step-item>
    </b-steps>
  </section>
</template>

<script>
import BasicDetails from '@/components/forms/BasicDetails'
import ContactInfo from '@/components/forms/ContactInfo'
import FinancialDetails from '@/components/forms/FinancialDetails'
import UploadFiles from '@/components/forms/UploadFiles'
import Documents from '@/components/forms/Documents'
import { mapActions, mapState } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  components: {
    BasicDetails,
    ContactInfo,
    FinancialDetails,
    UploadFiles,
    DocumentsForm: Documents
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('user', ['rol'])
  },
  data: () => ({
    requestInfo: {
      basicDetails: {
        company: {
          name: null,
          fundationDate: null,
          teamSize: null,
          sector: null,
          activityInSector: null
        },
        proposal: null,
        proposalDescription: null,
        website: null,
        videoLink: null,
        competitors: null,
        alreadyIncome: null,
        alreadyClients: null
      },
      contactInfo: {
        founder: {
          name: null,
          surname: null,
          profession: null,
          phone: null,
          email: null,
          linkedin: null
        },
        companyAddress: {
          address: null,
          number: null,
          region: null,
          postCode: null,
          country: null
        },
        howMet: null,
        additionalInfo: null
      },
      financialDetails: {
        financingType: null,
        income: null,
        expenses: null
      },
      requestFiles: {
        companyPresentation: null,
        pitchDeck: null,
        lastAudits: null,
        accountBalance: null,
        financialPool: null,
        mainClientsList: null,
        otherMerchantDocuments: null,
        otherActivityDocuments: null,
        aditionalInfoDocuments: null,
        cloudInfoLink: null,
        otherFiles: []
      },
      documents: {
        proposal: {
          url: null,
          status: null
        },
        contractDraft: {
          url: null,
          status: null
        },
        invoice: {
          url: null,
          status: null
        },
        contract: {
          url: null,
          status: null
        },
        paymentAmount: null
      }
    },
    activeStep: 0
  }),
  beforeMount() {
    this.callGetOnboardRequestInfo()
  },
  methods: {
    ...mapActions('onBoard', [
      'getOnboardRequestInfo',
      'putUpdateOnboardRequestInfo',
      'postNewOnboardReviewRequest',
      'putUpdateOnboardRequest',
      'postRespondOnboardReviewRequest',
      'postRequestContractSignature',
      'postSendRequestInvoice'
    ]),
    setOnboardRequestInfo(data) {
      let self = this
      const kamelData = this.keysToCamel(data)
      const dataKeys = [
        'basicDetails',
        'contactInfo',
        'financialDetails',
        'requestFiles',
        'documents'
      ]
      dataKeys.forEach(function(k) {
        if (kamelData[k]) {
          self.requestInfo[k] = kamelData[k]
        }
      })
    },
    requestFilesReady() {
      let self = this
      self
        .putUpdateOnboardRequest({
          data: { status: `P3-REQUEST-FILES-READY` },
          requestId: self.id
        })
        .then(() => {
          alert(self.$t('El director corporativo será notificado'))
        })
    },
    callGetOnboardRequestInfo() {
      let self = this
      self.request(() =>
        self.getOnboardRequestInfo(self.id).then(function(response) {
          self.setOnboardRequestInfo(response.data)
        })
      )
    },
    callPutUpdateOnboardRequestInfo(data) {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequestInfo({ requestId: self.id, data: data })
          .then(function(response) {
            self.setOnboardRequestInfo(response.data)
            self.activeStep < 4 && self.activeStep++
          })
      )
    },
    callPostNewOnboardReviewRequest(data) {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequest({
            data: { status: `P3-${data.documentType.toUpperCase()}-SENT` },
            requestId: self.id
          })
          .then(() => {
            self
              .postNewOnboardReviewRequest({ requestId: self.id, data: data })
              .then(function() {
                self.callGetOnboardRequestInfo()
              })
          })
      )
    },
    callPostRespondOnboardReviewRequest() {
      let self = this
      self.request(() =>
        self
          .postRespondOnboardReviewRequest({ requestId: self.id })
          .then(function() {
            self.callGetOnboardRequestInfo()
          })
      )
    },
    callPostRequestContractSignature: function() {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequest({
            data: { status: `P3-CPC` },
            requestId: self.id
          })
          .then(() => {
            self
              .postRequestContractSignature({
                requestId: self.id
              })
              .then(function() {
                self.callGetOnboardRequestInfo()
              })
          })
      )
    },
    callPostSendRequestInvoice: function(data) {
      let self = this
      self.request(() =>
        self
          .putUpdateOnboardRequest({
            data: { status: `P3-INVOICE-SENT` },
            requestId: self.id
          })
          .then(() => {
            self.postSendRequestInvoice({
              requestId: self.id,
              url: data.url
            })
          })
      )
    }
  }
}
</script>
